export default class Device {
    constructor(public connectionId: string, public nickname: string) {
      this.connectionId = connectionId;
      this.nickname = nickname;
    }
  }